"use client";

import { InMemoryDataRepository } from "./data/repositories";
import { SAMPLE_DATA } from "./data/sample-data";
import { IdGenerator} from "../fx/twitter-snowflake";
import { context } from "./context";
import { persistentDictionary } from "./adapters/local-storage";

console.log("Loading: services.ts");

export function useIdGenerator() { return idGenerator; }

const idGenerator = new IdGenerator({
  machineId: 0n,
});

const dataGenerator = new SAMPLE_DATA.DataGenerator();

const DATA = new InMemoryDataRepository({ dataGenerator });

export const SERVICES = () => {
  const CTX = context();
  const PD  = persistentDictionary();

  return { CTX, PD, DATA };
}

console.log("Loaded FE: services.ts");
